import imageMale from 'assets/img/male.png'
import imageFemale from 'assets/img/female.png'
import {Trans} from 'react-i18next'
import i18next from "i18next";
import { checkAndGetSessionStorageValue } from "../../../features/utils";

export default ({fields, invalidFields, setFields, actions, state }) => {
    let borderStyle = invalidFields && invalidFields.gender ? '2px solid red' : 'none';
    return (
        <>
            <fieldset>
                <div className="standby-page-section-row standby-page-section-row-flex standby-page-section-row-flex-spaced standby-page-section-row-flex-align-center standby-form-fieldset">
                    <div className={`${!(state && state.isTravelAid2)? "standby-col standby-col-shrink standby-form-legend": "gender-label"}`}>
                        <legend>
                            {
                            !state.isTravelAid2 ? 
                            <h2 className="standby-form-legend-text">
                                <Trans i18nKey="findcareoption.Start.Birthgender">Sex assigned at birth?</Trans>
                            </h2>
                            : 
                            <h5 className="standby-form-legend-text">
                                <Trans i18nKey="findcareoption.Start.Birthgender">Sex assigned at birth?</Trans>
                            </h5>
                            }
                        </legend>
                    </div>
                    <div className={`${!(state && state.isTravelAid2)? "standby-col standby-form-inline-fields gender-select-container": "radio-container"}`}>            
                        <label htmlFor="rbMale" id="lblRadioMale" className={`${!(state && state.isTravelAid2)? "standby-form-field-radio mt-3" : "male-label"}`}
                        style={{border: borderStyle}}>
                            <input
                                type="radio"
                                name="gender"
                                id="rbMale"
                                value="M"
                                aria-label={i18next.t("findcareoption.Start.Birthgender")+ " " + i18next.t("findcareoption.Start.Male")}
                                className={`${!(state && state.isTravelAid2)?"standby-form-field-radio-input": "radio-male"}`}
                                defaultChecked={fields.gender==='M'}
                                onClick={() => {
                                    setFields({
                                            gender: "M",
                                            pregnant: "",
                                            selectChildBirth: "",
                                            selectRecentPhysicalInjury: "",
                                    });
                                    if (!document.getElementById("rbMale").checked 
                                        && !document.getElementById("rbFemale").checked)
                                    {
                                        document.getElementById('lblRadioMale').style.border = 'borderStyle';
                                        document.getElementById('lblRadioFemale').style.border = 'borderStyle';
                                        document.getElementById('errorGender').style.display = 'block';
                                    }
                                    else
                                    {
                                        invalidFields.gender = '';
                                        document.getElementById('lblRadioMale').style.border = '';
                                        document.getElementById('lblRadioFemale').style.border = '';
                                        document.getElementById('errorGender').style.display = 'none';
                                    }
                                }}
                            />
                            {state && state.isTravelAid2? "" : 
                            <img role="img" src={imageMale} /> }
                            <span className={`${!(state && state.isTravelAid2)?"span-color-override": "span-male"}`} ><Trans i18nKey="findcareoption.Start.Male">Male</Trans></span>
                        </label>
                        <label htmlFor="rbFemale" id="lblRadioFemale" className={`${!(state && state.isTravelAid2)? "standby-form-field-radio mt-3" : checkAndGetSessionStorageValue("languageCode") == "es" ? "female-label female-label-es" : checkAndGetSessionStorageValue("languageCode") == "en" ? "female-label female-label-en" : checkAndGetSessionStorageValue("languageCode") == "fr" ? "female-label female-label-fr" : "female-label female-label-de"}`}
                        style={{border: borderStyle}}>
                            <input
                                type="radio"
                                name="gender"
                                id="rbFemale"
                                aria-label={i18next.t("findcareoption.Start.Birthgender")+ " " + i18next.t("findcareoption.Start.Female")}
                                value="F"
                                className={`${!(state && state.isTravelAid2)?"standby-form-field-radio-input": checkAndGetSessionStorageValue("languageCode") == "es" ? "es-radio-female " : checkAndGetSessionStorageValue("languageCode") == "en" ? "en-radio-female" : "radio-female"}`}
                                defaultChecked={fields.gender==='F'}
                                onClick={async () => {
                                    setFields({
                                        gender: "F",
                                        pregnant: "",
                                        selectChildBirth: "",
                                        selectRecentPhysicalInjury: "",
                                    });
                                    if (!document.getElementById("rbMale").checked 
                                        && !document.getElementById("rbFemale").checked)
                                    {
                                        document.getElementById('lblRadioMale').style.border = 'borderStyle';
                                        document.getElementById('lblRadioFemale').style.border = 'borderStyle';
                                        document.getElementById('errorGender').style.display = 'block';
                                    }
                                    else
                                    {
                                        invalidFields.gender = '';
                                        document.getElementById('lblRadioMale').style.border = '';
                                        document.getElementById('lblRadioFemale').style.border = '';
                                        document.getElementById('errorGender').style.display = 'none';
                                    }
                                }}
                            />
                            {state && state.isTravelAid2? "" : 
                            <img role="img" src={imageFemale} /> }
                            <span className={`${!(state && state.isTravelAid2)?"span-color-override": "span-female"}`}><Trans i18nKey="findcareoption.Start.Female">Female</Trans></span>
                        </label>
                    </div>
                </div>
            </fieldset>
            <div id="errorGender" className="errormessage-phone" style={{ display: invalidFields.gender ? "block" : "none",marginRight:3}}>
                {i18next.t("findcareoption.Start.errorMessages.errorBirthGender")}
            </div>
        </>
)
}